<template>
  <v-container fluid>
    <v-row style="margin-top: -20px; margin-left: 50px;">
      <v-col cols="12" lg="12" md="12">
        <span style="color: #0A7EA5; font-size: 16px; cursor: pointer;" @click="getBackList()" class="hover-back">
          &lt;Back
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1" lg="1" md="1" />
      <v-col cols="11" lg="11" md="11">
        <v-row style="margin-top: 20px;">
          <v-col cols="12" lg="12" md="12" style="margin-left:  auto; margin-right: auto;">
            <v-row>
              <v-col cols="12" lg="12" md="12" class="d-flex">
                <v-row>
                  <v-col cols="12" lg="12" md="12">
                    <span style="color: #222222; font-size: 25px; font-weight: 500;">Request Time Off</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1" lg="1" md="0" />
      <v-col cols="11" lg="6" md="7">
        <v-row>
          <v-col cols="6">
            <span class="text-title">Leave Type</span>
            <v-select class="pt-2" v-model="leave_data.leaveTypeId" label="Leave Type" solo fluid item-text="leave_type"
              item-value="leave_type_id" :items="dropdownLeave" outlined dense @change="onLeaveTypeChange"></v-select>
          </v-col>
          <v-col cols="6" class="mt-5">
            <v-radio-group v-model="day_select" row @change="handleRadioDaySelect">
              <v-radio label="Single day" value="single"></v-radio>
              <v-radio label="Multiple days" value="multiple"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row v-if="leave_data.leaveTypeId != 0" style="margin-top: -50px;">
          <v-col cols="12">
            <span class="text-title pl-1" style="font-size: 14px;">{{
              textshow
            }}</span>
          </v-col>
        </v-row>

        <v-row align="end" style="margin-top: 10px;">
          <v-col cols="6">
            <span class="text-title">From</span>
            <v-menu ref="menu_start" v-model="menu_start" :close-on-content-click="false" transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="computedDateFromFormatted" append-icon="mdi-calendar" readonly v-bind="attrs"
                  v-on="on" solo outlined dense></v-text-field>
              </template>
              <v-date-picker v-model="date_start" no-title scrollable :allowed-dates="allowedDates"
                @change="checkHoliday(date_start, 'start')">
                <v-btn text color="primary" @click="menu_start = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.menu_start.save(date_start)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <v-select v-model="leave_start_hours" :items="leave_hours" solo outlined dense></v-select>
          </v-col>
        </v-row>

        <v-row v-if="day_select == 'multiple'" align="end" style="margin-top: -25px;">
          <v-col cols="6">
            <span class="text-title">To</span>
            <v-menu ref="menu_end" v-model="menu_end" :close-on-content-click="false" transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="computedDateToFormatted" append-icon="mdi-calendar" readonly v-bind="attrs"
                  v-on="on" solo outlined dense></v-text-field>
              </template>
              <v-date-picker v-model="date_end" no-title scrollable :allowed-dates="allowedDates"
                @change="checkHoliday(date_end, 'end')">
                <v-btn text color="primary" @click="menu_end = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.menu_end.save(date_end)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <v-select v-model="leave_end_hours" :items="leave_hours" solo outlined dense></v-select>
          </v-col>
        </v-row>

        <v-textarea v-model="leave_data.description" label="Note" outlined rows="2"></v-textarea>

        <v-btn class="btnuploadfile" @click="$refs.file.click()" elevation="4">
          <v-icon left>mdi-cloud-upload</v-icon> Upload Image
        </v-btn>
        <input type="file" accept="image/*" multiple ref="file" style="display: none" @change="previewMultiImage" />

        <v-card v-if="preview_list.length" style="width: 100%; margin: 30px 0 30px 0;">
          <v-row>
            <v-col v-for="(item, index) in preview_list" :key="index" cols="3">
              <v-img :src="item" aspect-ratio="1" contain @click="deleteItemConfirm(index)"></v-img>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="1" lg="1" md="0" />
      <v-col cols="11" lg="3" md="3">
        <v-row>
          <v-col cols="12" lg="12" md="12" style="margin-left:  auto; margin-right: auto;" class="d-flex">
            <v-row class="align-center">
              <v-col cols="12" lg="12" md="12" style="padding-right: 50px;">
                <span style="color: #222222; font-size: 18px;">As of Today</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="12" md="12" style="margin-left:  auto; margin-right: auto;" class="d-flex">
            <v-row class="align-center">
              <v-col cols="12" lg="12" md="12" style="padding-right: 50px;">
                <v-card class="pa-6 box-show" elevation="0" style="background-color: #d0e9f1; margin:  auto;">
                  <v-row justify="center" align="center">
                    <v-col cols="2" md="2" lg="2">
                      <v-row>
                        <v-icon size="25" style="color: #0A7EA5;">mdi-check-circle-outline</v-icon>
                      </v-row>
                    </v-col>
                    <v-col cols="10" md="10" lg="7">
                      <v-row class="d-flex" align="center">
                        <span style="font-size: 16px;"><b>{{ vacation_day }}</b></span>&nbsp;
                        <span style="font-size: 12px; padding-top: 2px;">Days</span>
                        &nbsp;&nbsp;&nbsp;<span style="font-size: 16px;"><b>{{ vacation_hours }}</b></span>&nbsp;<span
                          style="font-size: 12px; padding-top: 2px;">Hours</span>
                      </v-row>
                      <v-row class="d-flex" align="center" style="margin-top: 10px;">
                        <span style="font-size: 10px;">Available to book time off</span>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="12" md="12" style="margin-left:  auto; margin-right: auto;" class="d-flex">
            <v-row class="align-center">
              <v-col cols="12" lg="12" md="12" style="padding-right: 50px;">
                <v-card class="pa-6 box-show" elevation="0" style="background-color: #fbf2d9; margin:  auto;">
                  <v-row justify="center" align="center">
                    <v-col cols="2" md="2" lg="2">
                      <v-row>
                        <v-icon size="25" style="color: #ffbe5c;">mdi-alert-circle-outline</v-icon>
                      </v-row>
                    </v-col>
                    <v-col cols="10" md="10" lg="7">
                      <v-row class="d-flex" align="center">
                        <span style="font-size: 16px;"><b>{{ pending_cont }}</b></span>&nbsp;
                        <span style="font-size: 12px; padding-top: 2px;">Pending Requests</span>
                      </v-row>
                      <v-row class="d-flex" align="center" style="margin-top: 10px;">
                        <span style="font-size: 10px;">Awaiting manager approval</span>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="12" md="12" style="margin-left:  auto; margin-right: auto;" class="d-flex">
            <v-row class="align-center">
              <v-col cols="12" lg="12" md="12" style="padding-right: 50px;">
                <v-card class="pa-6 box-show" elevation="0" style="background-color: #efefef;  margin:  auto;">
                  <v-row justify="center" align="center">
                    <v-col cols="2" md="2" lg="2">
                      <v-row>
                        <v-icon size="25" style="color: #4e4e4e;">mdi-arrow-right-bold-circle-outline</v-icon>
                      </v-row>
                    </v-col>
                    <v-col cols="10" md="10" lg="7">
                      <v-row class="d-flex" align="center">
                        <span style="font-size: 16px;"><b>{{ approver_day }}</b></span>&nbsp;
                        <span style="font-size: 12px; padding-top: 2px;">Days</span>
                        &nbsp;&nbsp;&nbsp;<span style="font-size: 16px;"><b>{{ approver_hours }}</b></span>&nbsp;<span
                          style="font-size: 12px; padding-top: 2px;">Hours</span>
                      </v-row>
                      <v-row class="d-flex" align="center" style="margin-top: 10px;">
                        <span style="font-size: 10px;">Upcoming</span>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1" lg="1" md="0" />
    </v-row>

    <div>
      <v-row v-if="user_approve_count_status">
        <v-col align="center" cols="12" md="12" v-if="user_approve_count_status2">
          <v-btn class="mr-5" depressed style="
                    color: white;
                    background-color: #0A7EA5;
                    width: 200px;
              " @click="onSave()">
            Submit
          </v-btn>

          <v-btn depressed style="
                color: red;
                width: 200px;
                border: 1px solid red;
              " @click="cancelReauest()">
            Cancel
          </v-btn>
        </v-col>
        <v-col align="center" cols="12" md="2"> </v-col>
      </v-row>
    </div>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card style="padding-top: 30px; padding-bottom: 30px;">
        <v-card-title style="padding-bottom: 20px;">
          <v-row justify="center">
            <span class="red--text text-h5 ju">Are you sure?</span>
          </v-row>
        </v-card-title>
        <br />
        <v-card-subtitle>
          <v-row justify="center">
            <span class="black--text">Are you sure you want to delete this item</span>
          </v-row>
        </v-card-subtitle>
        <v-card-actions style="padding-top: 20px">
          <v-spacer></v-spacer>
          <v-btn style="
              color: white;
            " rounded class="mr-5" color="#0A7EA5" width="170" @click="removeimage">
            Save
          </v-btn>
          <v-btn style="
              color: white;
            " class="mr-2" color="red" width="170" rounded @click="closeDelete">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSave" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure ?</v-card-title>
        <br />
        <v-card-subtitle>
          <span class="black--text">Do you really want to send this leave request? This process cannot
            be undone.</span>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeSave">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="onSave">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCancel" max-width="500px">
      <v-card>
        <v-card-title style="padding-top: 80px; padding-bottom: 20px;">
          <v-row justify="center">
            <span class="red--text text-h5 ju">Are you sure?</span>
          </v-row>
        </v-card-title>
        <br />
        <v-card-subtitle>
          <v-row justify="center">
            <span class="black--text">This action cannot be undone.</span>
          </v-row>
        </v-card-subtitle>
        <v-card-actions style="padding-bottom: 50px; padding-top: 40px;">
          <v-spacer></v-spacer>
          <v-btn style="
              color: white;
            " rounded class="mr-5" color="#0A7EA5" width="170" @click="onCancelSave">
            Save
          </v-btn>
          <v-btn style="
              color: white;
            " class="mr-2" color="red" width="170" rounded @click="closeCancel">
            Cancel
          </v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

    <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
  </v-container>
</template>

<script>
import api from "@/services/api";
import { server, imageUrl } from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import "@lazy-copilot/datetimepicker/dist/datetimepicker.css";
import { DateTimePicker } from "@lazy-copilot/datetimepicker";
import unity from "@/unity/unity";

export default {
  name: "leave-request",
  components: { SuccessDialog, SuccessDialogPush, DateTimePicker },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  data(vm) {
    return {
      check_cross_per: "",
      day_select: "",
      select_leave_id: 0,
      user_approve_all: [],
      user_approve_count_status: false,
      user_approve_count_status2: false,
      date_start: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      date_end: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu_start: false,
      menu_end: false,
      leave_start_hours: "",
      leave_end_hours: "",
      leave_start_min: "",
      leave_end_min: "",
      leave_hours: [
        { text: "1 hour", value: 1 },
        { text: "2 hours", value: 2 },
        { text: "3 hours", value: 3 },
        { text: "Half day", value: 4 },
        { text: "5 hours", value: 5 },
        { text: "6 hours", value: 6 },
        { text: "7 hours", value: 7 },
        { text: "Full day", value: 8 },
      ],
      leave_min: [
        { text: "00", value: "00" },
        { text: "30", value: "30" },
      ],
      startDate: new Date(),
      endDate: new Date(),
      dialogDelete: false,
      dialogSave: false,
      dialogCancel: false,
      preview: null,
      image: null,
      preview_list: [],
      oldpreview_list: [],
      image_list: [],
      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dropdownLeave: [],
      dataAll: [],
      delete_his_id: 0,
      delete_lq_id: [],
      delete_amount: 0,
      update_delete_req: {},
      headers: [
        {
          text: "Period",
          value: "period",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Leave Type",
          value: "leave_type",
          class: "bg-colorth tabletextwhite",
        },
        // {
        //   text: "Quota (Day)",
        //   value: "quota_day_show",
        //   class: "bg-colorth tabletextwhite",
        // },
        // {
        //   text: "Used",
        //   value: "user_day_show",
        //   class: "bg-colorth tabletextwhite",
        // },
        {
          text: "Quota (Day)",
          value: "balance_show",
          class: "bg-colorth tabletextwhite",
        },
      ],
      leave_data: {},
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      vacation_day: 0,
      vacation_hours: 0,
      approver_day: 0,
      approver_hours: 0,
      pending_cont: 0,
      public_cont: 0,
      textshow: "",
      delete_old_images: [],
    };
  },

  computed: {
    computedDateFromFormatted() {
      return unity.formatDate(this.date_start);
    },
    computedDateToFormatted() {
      return unity.formatDate(this.date_end);
    },
    allowedDates() {
      return (date) => {
        date = new Date(date);
        const dayOfWeek = date.getDay();
        return dayOfWeek !== 0 && dayOfWeek !== 6; // Disable Sunday (0) and Saturday (6)
      };
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async mounted() {
    this.userId = localStorage.getItem(server.USER_ID);

    try {
      // 1. ตรวจสอบ approver ก่อน
      await this.loadLevelApprove(this.userId);

      // 2. โหลด history (จะได้ check_cross_per และ old quota data)
      await this.loadLeaveHistory(this.$route.params.id);

      // 3. โหลด dropdown และ quota (จะใช้ข้อมูลจาก step 2 ในการคำนวณ)
      await this.loaddataLeaveUsed(this.userId);

      // 4. โหลด quota summary
      await this.loadQuotaType();

      // 5. อัพเดทข้อความแสดง available days
      this.onLeaveTypeChange();

      this.$hideLoader();
    } catch (error) {
      console.error("❌ Error in mounted:", error);
      this.$hideLoader();
    }
  },

  methods: {
    onLeaveTypeChange() {
      // this.textshow = "test";
      if (this.dataAll && this.dataAll.length > 0) {
        const dataSet = this.dataAll.filter(
          (item) => item.leave_type_id === this.leave_data.leaveTypeId,
        );
        if (dataSet && dataSet.length == 1) {
          this.textshow = `(${dataSet[0].balance_show} avaliable this year)`;
        } else if (dataSet && dataSet.length > 1) {
          this.textshow = `(${dataSet[0].balance_show} avaliable this year, ${dataSet[1].balance_show} avaliable next year)`;
        } else {
          this.textshow = `(0 days avaliable this year)`;
        }
      } else {
      }
    },
    async loadQuotaType() {
      const res_leave_history = await api.getListHistoryAll(
        localStorage.getItem(server.USER_ID),
      );

      if (res_leave_history.data && res_leave_history.data.length > 0) {
        const filteredData = res_leave_history.data.filter(
          (item) => Number(item.status) === 1 || Number(item.status) === 2,
        );
        this.pending_cont = filteredData.length;
      } else {
        this.pending_cont = 0;
      }

      // const res_quota = await api.getListByUserDashboard(localStorage.getItem(server.USER_ID))
      if (this.dataAll && this.dataAll.length > 0) {
        const filteredData = this.dataAll.filter(
          (item) => item.leave_type === "Vacation Leave",
        );
        if (filteredData.length > 0) {
          var canuse_leave = 0;
          for (const [index, item] of filteredData.entries()) {
            canuse_leave = canuse_leave + Number(item.balance);
          }

          this.vacation_day = Math.floor(canuse_leave);
          this.vacation_hours = (canuse_leave - this.vacation_day) * 8;
        } else {
          this.vacation_day = 0;
          this.vacation_hours = 0;
        }
      } else {
        this.vacation_day = 0;
        this.vacation_hours = 0;
      }

      const res_holiday = await api.getAllYear(
        Number(localStorage.getItem(server.COMPANYID)),
      );
      if (res_holiday.data && res_holiday.data.length > 0) {
        this.public_cont = res_holiday.data.length;
      } else {
        this.public_cont = 0;
      }

      const res_approval = await api.getAllByApproval(
        Number(localStorage.getItem(server.USER_ID)),
      );
      if (res_approval.data && res_approval.data.length > 0) {

        this.approver_day = Math.floor(
          Number(res_approval.data[0].amount) / 60 / 8,
        );
        this.approver_hours = Math.floor(
          (Number(res_approval.data[0].amount) - this.approver_day * 60 * 8) /
          60,
        );
      } else {
        this.approver_day = 0;
        this.approver_hours = 0;
      }
    },
    async getBackList() {
      this.$router.push(`/my-time-off`);
    },
    async handleRadioDaySelect() {
      if (this.day_select == "single") {
        this.leave_end_hours == "";
      } else if (this.day_select == "multiple") {
        this.leave_end_hours == "";
      } else {
        return;
      }
    },
    async loaddataLeaveUsed(id) {
      try {
        // 1. โหลด dropdown ก่อนเสมอ
        const result_dropdown = await api.getListByUserIDV2byCompanyforEdit(
          id,
          localStorage.getItem(server.COMPANYID),
        );

        // แปลง leave_type_id เป็น Number เพื่อให้ตรงกับ v-model
        this.dropdownLeave = result_dropdown.data.map((item) => ({
          ...item,
          leave_type_id: Number(item.leave_type_id),
        }));


        // 2. โหลดข้อมูล quota
        const result = await api.getListUseByUserIDV2byCompany(
          id,
          localStorage.getItem(server.COMPANYID),
        );


        // 3. ตรวจสอบว่ามีข้อมูล quota หรือไม่
        if (result.data.length <= 0) {
          this.user_approve_count_status2 = false;
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "No Time Off",
            "You do not have any time off permitted.",
            "text-h5 red--text text-center",
          );
          return;
        } else {
          this.user_approve_count_status2 = true;
        }

        // 4. ประมวลผลข้อมูล quota ตาม check_cross_per
        let data = [];

        if (this.check_cross_per == "single_period") {
          // กรณีลาในช่วงเดียว
          result.data.forEach((item) => {
            let obj = { ...item };

            if (item.id == this.leave_data.old_lq_id) {
              // คืนโควต้าเดิมกลับไปก่อน
              const returnedAmount =
                Number(this.leave_data.old_amount) / 60 / 8;
              obj.use_leave = item.use_leave - returnedAmount;
              obj.balance = Number(item.balance) + returnedAmount;
            }

            obj.user_day_show = this.quotaListConvert(obj.use_leave);
            obj.balance_show = this.quotaListConvert(obj.balance);
            obj.quota_day_show = this.quotaListConvert(item.quota_day);

            data.push(obj);
          });
        } else if (this.check_cross_per == "cross_period") {
          // กรณีลาข้ามช่วง
          const data_cross_quota = this.leave_data.old_amount_list;

          result.data.forEach((item) => {
            let obj = { ...item };
            let quotaAdjusted = false;

            // ตรวจสอบว่า quota นี้ต้องคืนเวลาหรือไม่
            data_cross_quota.forEach((cross_item) => {
              if (item.id == cross_item.old_lq_id) {
                quotaAdjusted = true;
                const returnedAmount = Number(cross_item.old_amount) / 60 / 8;
                obj.use_leave = item.use_leave - returnedAmount;
                obj.balance = Number(item.balance) + returnedAmount;
              }
            });

            obj.user_day_show = this.quotaListConvert(obj.use_leave);
            obj.balance_show = this.quotaListConvert(obj.balance);
            obj.quota_day_show = this.quotaListConvert(item.quota_day);

            data.push(obj);
          });
        }

        this.dataAll = data;
      } catch (error) {
        console.error("❌ Error in loaddataLeaveUsed:", error);
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Error",
          "ไม่สามารถโหลดข้อมูลได้",
          "text-h5 red--text text-center",
        );
      }
    },

    async loadLeaveHistory(his_id) {
      try {
        const res = await api.getLeaveHistoryByHistoryID(his_id);

        if (!res.data || res.data.length <= 0) {
          this.user_approve_count_status2 = false;
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "No Time Off",
            "You do not have any time off permitted.",
            "text-h5 red--text text-center",
          );
          return;
        }

        const historyData = res.data[0];

        if (res.data.length > 1) {
          this.check_cross_per = "cross_period";
        } else if (res.data.length == 1) {
          this.check_cross_per = "single_period";
        }

        this.leave_data.leaveType = historyData.leavetype;
        this.leave_data.leaveTypeId = Number(historyData.leavetypeid);
        this.day_select = historyData.type_count;
        this.leave_data.type_count = historyData.type_count;
        this.leave_data.userId = historyData.userid;
        this.leave_data.departmentId = historyData.departmentid;
        this.leave_data.companyId = historyData.companyid;
        this.leave_data.description = historyData.description;


        const foundInDropdown = this.dropdownLeave.find(
          (item) => item.leave_type_id === this.leave_data.leaveTypeId,
        );

        this.leave_data.startDate = historyData.startdate;
        this.leave_data.endDate = historyData.enddate;
        this.date_start = new Date(historyData.startdate)
          .toISOString()
          .substr(0, 10);
        this.date_end = new Date(historyData.enddate)
          .toISOString()
          .substr(0, 10);

        this.leave_start_hours = Number(historyData.starthour);

        if (historyData.type_count == "single") {
          this.leave_end_hours = 0;
        } else if (historyData.type_count == "multiple") {
          this.leave_end_hours = Number(historyData.endhour);
        }

        // จัดการรูปภาพ - เพิ่มเข้า preview_list ด้วย
        this.oldpreview_list = [];
        this.preview_list = []; // เคลียร์ก่อน

        if (historyData.images && historyData.images !== "") {
          const imageFiles = historyData.images.split(",");
          imageFiles.forEach((filename) => {
            const imageUrldata = `${imageUrl}/${filename.trim()}`;
            this.oldpreview_list.push(imageUrldata);
            this.preview_list.push(imageUrldata); // เพิ่มเข้า preview_list ด้วย
          });
        }


        if (this.check_cross_per == "single_period") {
          this.leave_data.old_amount = historyData.amount_detail;
          this.leave_data.old_lq_id = historyData.lq_id_detail;
          this.delete_lq_id = [{ old_lq_id: historyData.lq_id_detail }];


        } else if (this.check_cross_per == "cross_period") {
          const data_cross_per = res.data.map((item) => ({
            old_amount: item.amount_detail,
            old_lq_id: item.lq_id_detail,
          }));

          this.leave_data.old_amount_list = data_cross_per;
          this.delete_lq_id = data_cross_per;

        }

      } catch (error) {
        console.error("❌ Error in loadLeaveHistory:", error);
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Error",
          "ไม่สามารถโหลดประวัติการลาได้",
          "text-h5 red--text text-center",
        );
      }
    },

    async checkHoliday(date, mode) {
      // alert(date)
      const res_date = await api.getLeaveHolidayByDate(
        date,
        Number(localStorage.getItem(server.COMPANYID)),
      );

      if (res_date.data.length > 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          `ไม่สามารถเลือกได้เนื่องจาก ${unity.formatDate(date)} เป็นวันหยุด ${res_date.data[0].h_name
          }`,
          "text-h5 red--text text-center",
        );
        return;
      }
    },
    async loadLevelApprove(userId) {
      const res_acc = await api.getAccountid(userId);
      // console.log("res_acc", JSON.stringify(res_acc.data));

      if (
        res_acc.data[0].approver_level1 !== null ||
        res_acc.data[0].approver_level1 !== ""
      ) {
        this.user_approve_count_status = true;
        this.user_approve_all.push(res_acc.data[0].approver_level1);
      } else {
        this.user_approve_count_status = false;

        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ไม่มีผู้อนุมัติ",
          "คุณไม่มีผู้อนุมัติ กรุณาเพิ่มผู้อนุมัติด้วย",
          "text-h5 red--text text-center",
        );
        return;
      }

      if (
        res_acc.data[0].approver_level2 !== null ||
        res_acc.data[0].approver_level2 !== ""
      ) {
        this.user_approve_count_status = true;
        this.user_approve_all.push(res_acc.data[0].approver_level2);
      }

      if (
        res_acc.data[0].approver_level3 !== null ||
        res_acc.data[0].approver_level3 !== ""
      ) {
        this.user_approve_count_status = true;
        this.user_approve_all.push(res_acc.data[0].approver_level3);
      }
    },

    checkDateFormat(str_date) {
      var r_date = "";

      if (str_date.length == 1) {
        r_date = `0${str_date}`;
      } else {
        r_date = str_date;
      }
      return r_date;
    },

    async onSave() {
      this.dialogSave = false;

      //validate ข้อมูล
      if (this.leave_data.leaveTypeId == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณาเลือกประเภทการลา",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (
        this.leave_start_hours === null ||
        this.leave_start_hours === "" ||
        this.leave_start_hours === 0
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "Please select a time period ",
          "text-h5 red--text text-center",
        );
        return;
      }

      const res_date_start = await api.getLeaveHolidayByDate(
        this.date_start,
        Number(localStorage.getItem(server.COMPANYID)),
      );
      if (res_date_start.data.length > 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          `ไม่สามารถเลือกได้เนื่องจาก ${unity.formatDate(
            this.date_start,
          )} เป็นวันหยุด ${res_date_start.data[0].h_name}`,
          "text-h5 red--text text-center",
        );
        return;
      }

      if (this.day_select == "multiple") {
        if (this.date_start >= this.date_end) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check your information again",
            "คุณเลือกช่วงเวลาไม่ถูกต้อง",
            "text-h5 red--text text-center",
          );
          return;
        }

        const res_date_end = await api.getLeaveHolidayByDate(
          this.date_end,
          Number(localStorage.getItem(server.COMPANYID)),
        );
        if (res_date_end.data.length > 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check your information again",
            `ไม่สามารถเลือกได้เนื่องจาก ${unity.formatDate(
              this.date_end,
            )} เป็นวันหยุด ${res_date_end.data[0].h_name}`,
            "text-h5 red--text text-center",
          );
          return;
        }

        if (
          this.leave_end_hours === null ||
          this.leave_end_hours === "" ||
          this.leave_end_hours === 0
        ) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check your information again",
            "Please select a time period ",
            "text-h5 red--text text-center",
          );
          return;
        }
      }

      //รวมเวลา start end
      if (this.day_select == "single") {
        this.leave_data.startDate = this.date_start + " 08:30";
        this.leave_data.endDate = this.date_start + " 17:30";
      } else if (this.day_select == "multiple") {
        this.leave_data.startDate = this.date_start + " 08:30";
        this.leave_data.endDate = this.date_end + " 17:30";
      } else {
        return;
      }
      //end validate ข้อมูล

      //เช็ค เวลาตรงกับช่วงเวลาที่มีหรือไหม
      let res_chk_period = [];
      if (this.day_select == "single") {
        res_chk_period = await api.getAllCheckPeriodByLeaveType(
          localStorage.getItem(server.USER_ID),
          this.date_start,
          this.date_start,
          this.leave_data.leaveTypeId,
        );
      } else if (this.day_select == "multiple") {
        res_chk_period = await api.getAllCheckPeriodByLeaveType(
          localStorage.getItem(server.USER_ID),
          this.date_start,
          this.date_end,
          this.leave_data.leaveTypeId,
        );
      } else {
        return;
      }


      if (res_chk_period.data.length == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "วันลา ไม่อยู่ในช่วงที่กำหนด",
          "text-h5 red--text text-center",
        );
        return;
      }
      //end การเช็คช่วงเวลา

      let period_data = [];
      period_data = res_chk_period.data;

      const millisecondsInOneDay = 24 * 60 * 60 * 1000;

      // let startDate = new Date(this.date_start);
      // let endDate = new Date(this.date_end);


      let sum_avg_minutes = 0;
      let avg_minutes_list = [];
      let leave_quota_list = "";

      if (this.day_select == "single") {
        //start คำนวณวันลา
        let avg_minutes = 0; //เวลาที่ลา เป็นนาที
        avg_minutes = Number(this.leave_start_hours) * 60;
        //end คำนวณวันลา

        // //start เช็คโคต้าวันลา
        var quota_amt = 0; //โควต้าวันลาเป็นนาที

        this.dataAll.forEach((item) => {
          if (item.id == period_data[0].leave_quota_id) {
            this.leave_data.lq_id_detail = period_data[0].leave_quota_id;
            quota_amt = item.balance * 480;
          }
        });

        if (avg_minutes > quota_amt) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ลาเกิน",
            "คุณลาเกินวันลาที่มี",
            "text-h5 red--text text-center",
          );
          return;
        }
        //end เช็คโคต้าวันลา

        //start เพิ่มข้อมูลลาไม่เกิน1วัน
        this.leave_data.amount = avg_minutes;
        this.leave_data.userId = localStorage.getItem(server.USER_ID);
        this.leave_data.departmentId = localStorage.getItem(
          server.DEPARTMENT_ID,
        );
        this.leave_data.companyId = localStorage.getItem(server.COMPANYID);

        this.$showLoader();

        let formData = new FormData();

        this.image_list.forEach((x, index) => {
          formData.append(`image`, x);
        });

        const keptOldImages = this.oldpreview_list
          .filter((url) => this.preview_list.includes(url)) // เก็บเฉพาะรูปเก่าที่ยังไม่ถูกลบ
          .map((url) => url.split("/").pop())               // ดึงชื่อไฟล์จาก URL
          .join(",");


        formData.append("images", keptOldImages.toString());
        formData.append("leaveType", this.leave_data.leaveTypeId.toString());
        formData.append("leaveTypeId", this.leave_data.leaveTypeId.toString());
        formData.append("approve_id_now", this.user_approve_all[0]);
        formData.append(
          "startDate",
          this.leave_data.startDate.replace("+07:00", ""),
        );
        formData.append("startHour", this.leave_start_hours);
        formData.append(
          "endDate",
          this.leave_data.endDate.replace("+07:00", ""),
        );
        formData.append("endHour", 0);
        formData.append("type_count", this.day_select);
        formData.append("description", this.leave_data.description);
        formData.append("userId", this.leave_data.userId);
        formData.append("departmentId", this.leave_data.departmentId);
        formData.append("companyId", this.leave_data.companyId);
        formData.append("amount", this.leave_data.amount);
        formData.append("lq_id_detail", this.leave_data.lq_id_detail);

        const res_h = await api.updateLeaveHistory(
          this.$route.params.id,
          formData,
        );
        if (res_h.status == 200 || res_h.status == 201) {
          // console.log("res_h:", JSON.stringify(res_h.data));
          // this.user_approve_all.forEach((item) => {
          //   var data = {
          //     leave_his_id: res_h.data.module_id,
          //     approve_id: item,
          //   };
          //   api.addLeaveApproveDetail(data);
          // });

          // ✅ เพิ่ม: ลบไฟล์รูปเก่าที่ถูกลบออกจากฟอร์ม (เฉพาะตอน submit สำเร็จ)
          if (this.delete_old_images.length > 0) {
            try {
              for (const filename of this.delete_old_images) {
                const datadel = {
                  modulename: "Pro_file",
                  filetype: "image",
                  refid: "",
                  filename: filename,
                };

                await api.deleteFileStore({
                  params: datadel,
                });
              }

              this.delete_old_images = [];
            } catch (error) {
              console.error("❌ Error deleting old images:", error);
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Error",
                "ไม่สามารถลบรูปภาพเก่าได้",
                "text-h5 red--text text-center",
              );
              this.$hideLoader();
              return;
            }
          }

          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "Request Submitted",
            "You have submitted this request.",
            "text-h5 green--text text-center",
            "/my-time-off",
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "บันทึกข้อมูลไม่สำเร็จ",
            "text-h5 red--text text-center",
          );
        }
        this.$hideLoader();
      } else if (this.day_select == "multiple") {
        let quota_check = 0;
        for (const [index, item] of period_data.entries()) {
          let avg_minutes = 0;

          let startDateMany = new Date(item.leave_date_start);
          let endDateMany = new Date(item.leave_date_end);

          while (startDateMany <= endDateMany) {
            const dayOfWeekMany = startDateMany.getDay();

            // Check if the day is not Saturday (6) or Sunday (0)
            if (dayOfWeekMany !== 6 && dayOfWeekMany !== 0) {
              var data_check = startDateMany.toISOString().substr(0, 10);
              var res_date_check = await api.getLeaveHolidayByDate(
                data_check,
                Number(localStorage.getItem(server.COMPANYID)),
              );
              if (res_date_check.data.length == 0) {
                avg_minutes += 8 * 60;
              }
            }

            startDateMany.setTime(
              startDateMany.getTime() + millisecondsInOneDay,
            );
          }

          //start บวกขอบ ของวัน
          if (period_data.length == 1) {
            avg_minutes =
              avg_minutes -
              2 * 8 * 60 +
              Number(this.leave_start_hours) * 60 +
              Number(this.leave_end_hours) * 60;
          } else if (period_data.length > 1) {
            if (index == 0) {
              avg_minutes =
                avg_minutes - 1 * 8 * 60 + Number(this.leave_start_hours) * 60;
            }
            if (index == period_data.length - 1) {
              avg_minutes =
                avg_minutes - 1 * 8 * 60 + Number(this.leave_end_hours) * 60;
            }
          } else {
            return;
          }

          //end บวกขอบ ของวัน
          //start เช็คโคต้าวันลา
          var quota_amt = 0; //โควต้าวันลาเป็นนาที

          this.dataAll.forEach((item) => {
            if (Number(item.id) == Number(period_data[index].leave_quota_id)) {
              this.leave_data.lq_id = period_data[index].leave_quota_id;
              quota_amt = Number(item.balance) * 480;
            }
          });



          if (avg_minutes > quota_amt) {
            quota_check = 1;
          }
          //end เช็คโคต้าวันลา

          // console.log("avg_minutes: " + avg_minutes)
          sum_avg_minutes += avg_minutes;
          if (index > 0) {
            leave_quota_list += `,${item.leave_quota_id}`;
          } else {
            leave_quota_list += `${item.leave_quota_id}`;
          }

          avg_minutes_list.push({
            leave_quota_id: item.leave_quota_id,
            avg_minutes: avg_minutes,
          });
        }

        // alert(quota_check)
        if (quota_check == 1) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ลาเกิน",
            "คุณลาเกินวันลาที่มี",
            "text-h5 red--text text-center",
          );
          return;
        }

        //start เพิ่มข้อมูลลาเกิน1วัน
        this.leave_data.amount = sum_avg_minutes;
        this.leave_data.userId = localStorage.getItem(server.USER_ID);
        this.leave_data.departmentId = localStorage.getItem(
          server.DEPARTMENT_ID,
        );
        this.leave_data.companyId = localStorage.getItem(server.COMPANYID);

        this.$showLoader();

        // console.log("leave_data:", JSON.stringify(this.leave_data));

        let formData = new FormData();

        this.image_list.forEach((x, index) => {
          formData.append(`image`, x);
        });

        const keptOldImages = this.oldpreview_list
          .filter((url) => this.preview_list.includes(url)) // เก็บเฉพาะรูปเก่าที่ยังไม่ถูกลบ
          .map((url) => url.split("/").pop())               // ดึงชื่อไฟล์จาก URL
          .join(",");


        formData.append("images", keptOldImages.toString());
        formData.append("leaveType", this.leave_data.leaveTypeId.toString());
        formData.append("leaveTypeId", this.leave_data.leaveTypeId.toString());
        formData.append("approve_id_now", this.user_approve_all[0]);
        formData.append(
          "startDate",
          this.leave_data.startDate.replace("+07:00", ""),
        );
        formData.append("startHour", this.leave_start_hours);
        formData.append(
          "endDate",
          this.leave_data.endDate.replace("+07:00", ""),
        );
        formData.append("endHour", this.leave_end_hours);
        formData.append("type_count", this.day_select);
        formData.append("description", this.leave_data.description);
        formData.append("userId", this.leave_data.userId);
        formData.append("departmentId", this.leave_data.departmentId);
        formData.append("companyId", this.leave_data.companyId);
        formData.append("amount", this.leave_data.amount);
        formData.append("lq_id_detail", leave_quota_list);

        let lq_id_v = "";
        avg_minutes_list.forEach((item, index) => {
          if (index == 0) {
            lq_id_v += `{ "lq_id_v": ${item.leave_quota_id}, "avg_minutes": ${item.avg_minutes}}`;
          } else {
            lq_id_v += `|{ "lq_id_v": ${item.leave_quota_id}, "avg_minutes": ${item.avg_minutes}}`;
          }
        });

        formData.append("lq_id_v", lq_id_v);

        const res_h = await api.updateLeaveHistory(
          this.$route.params.id,
          formData,
        );
        if (res_h.status == 200 || res_h.status == 201) {
          if (this.delete_old_images.length > 0) {
            try {
              for (const filename of this.delete_old_images) {
                const datadel = {
                  modulename: "Pro_file",
                  filetype: "image",
                  refid: "",
                  filename: filename,
                };

                await api.deleteFileStore({
                  params: datadel,
                });
              }

              this.delete_old_images = [];
            } catch (error) {
              console.error("❌ Error deleting old images:", error);
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Error",
                "ไม่สามารถลบรูปภาพเก่าได้",
                "text-h5 red--text text-center",
              );
              this.$hideLoader();
              return;
            }
          }

          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "Request Submitted",
            "You have submitted this request.",
            "text-h5 green--text text-center",
            "/my-time-off",
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "บันทึกข้อมูลไม่สำเร็จ",
            "text-h5 red--text text-center",
          );
        }
        this.$hideLoader();
      } else {
        return;
      }
    },

    async onCancelSave() {
      this.dialogCancel = false;

      this.$showLoader();


      if (this.delete_lq_id.length > 0) {
        //ลบ leave history
        const res_dlq = await api.delete_leaveH(this.$route.params.id);


        if (res_dlq.data.id) {
          await api.delete_leaveQHD(this.$route.params.id);
          await api.delete_leaveAD(this.$route.params.id);
          this.delete_lq_id.forEach(async (item, index) => {
            var update_check = 0;
            var use_leave_c = 0;
            this.dataAll.forEach((items) => {
              if (items.id == item.old_lq_id) {
                use_leave_c = items.use_leave;
              }
            });

            this.update_delete_req.use_leave = use_leave_c;

            const res_ulq = await api.updateQuota(
              item.old_lq_id,
              this.update_delete_req,
            );
            if (res_ulq.status == 200 || res_ulq.status == 201) {
              update_check = 1;
            }
            if (update_check == 1) {
              if (index == this.delete_lq_id.length - 1) {
                this.$hideLoader();
                this.$store.state.global_push_dialog = true;
                this.setupAlertDialogPush(
                  true,
                  "Request Canceled",
                  "You have canceled this request.",
                  "text-h5 green--text text-center",
                  "/my-time-off",
                );
                return;
              }
            } else {
              this.$hideLoader();
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Information Saved",
                "บันทึกข้อมูลไม่สำเร็จ",
                "text-h5 red--text text-center",
              );
              return;
            }
          });
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "บันทึกข้อมูลไม่สำเร็จ",
            "text-h5 red--text text-center",
          );
          return;
        }
      }
      // this.$hideLoader();
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    saveItemConfirm() {
      this.dialogSave = true;
    },
    cancelReauest() {
      this.dialogCancel = true;
    },
    closeSave() {
      this.dialogSave = false;
    },
    closeCancel() {
      this.dialogCancel = false;
    },
    deleteItemConfirm(index) {
      this.indeximage = index;
      this.dialogDelete = true;
    },
    closeDelete() {
      this.indeximage = null;
      this.dialogDelete = false;
    },
    async removeimage() {
      const removedUrl = this.preview_list[this.indeximage];

      // เช็คว่าเป็นรูปเก่า (มีอยู่จริงบน server) หรือรูปใหม่ (ยัง local)
      const oldIndex = this.oldpreview_list.indexOf(removedUrl);

      if (oldIndex !== -1) {
        // เป็นรูปเก่า -> เก็บชื่อไฟล์ไว้ก่อน รอลบจริงตอน submit
        const filename = removedUrl.split("/").pop();
        this.delete_old_images.push(filename);
        this.oldpreview_list.splice(oldIndex, 1);
      } else {
        // เป็นรูปใหม่ที่ยังไม่ upload -> ลบออกจาก image_list ตรงตัว
        const newImageIndex = this.indeximage - this.oldpreview_list.length;
        if (newImageIndex >= 0 && newImageIndex < this.image_list.length) {
          this.image_list.splice(newImageIndex, 1);
        }
      }

      this.preview_list.splice(this.indeximage, 1);
      this.dialogDelete = false;
    },
    quotaListConvert: function (H) {
      var d = 0;
      var h = 0;
      var m = 0;
      var tmp1 = parseFloat(H * 480);
      var tmp_final;

      var tmp_d = tmp1 / 480;

      d = Math.floor(tmp_d);
      h = Math.floor((tmp_d - d) * 8);
      m = Math.floor(((tmp_d - d) * 8 - h) * 60);

      tmp_final = `${d} days ${h} hour`;

      return tmp_final;
    },

    previewMultiImage: function (event) {
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.preview_list.push(e.target.result);
          };
          if (input.files[index].type.split("/")[0] === "image") {
            this.image_list.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
      console.log(this.image_list);
    },
  },
};
</script>

<style>
.heightsize80 {
  height: 85px;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.heightsize55 {
  height: 55px;
}

.heightsize30 {
  height: 30px;
}

.inputsize {
  font-size: smaller;
}

.btnuploadfile {
  border: 2px solid;
}

.border-dt-picker {
  border: 2px solid;
  border-radius: 5px;
  height: 45px;
}

.heightsize70formadvance {
  height: 70px;
}
</style>
